/**
 * Patient Quick Switch Component
 */

import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { ScrollArea } from "../ui/scroll-area";
import { X } from "lucide-react";

export function PatientQuickSwitch({ patients, selectedPatient, onSelectPatient, isOpen, onClose }) {
  const [searchQuery, setSearchQuery] = useState("");
  
  const filteredPatients = patients.filter(p => 
    p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    p.mrn?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div 
      className={`fixed right-0 top-0 h-full w-full sm:w-80 bg-slate-900 border-l border-slate-700 transform transition-transform z-50 ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      data-testid="patient-quick-switch"
    >
      <div className="p-4 border-b border-slate-700">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-white">Quick Switch</h3>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-4 h-4" />
          </Button>
        </div>
        <Input
          placeholder="Search patients..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500"
          data-testid="patient-search-input"
        />
      </div>
      <ScrollArea className="h-[calc(100%-120px)]">
        <div className="p-2 space-y-1">
          {filteredPatients.map(patient => (
            <div
              key={patient.id}
              className={`p-3 rounded-lg cursor-pointer transition-colors ${
                selectedPatient?.id === patient.id 
                  ? "bg-teal-600/20 border border-teal-500/50" 
                  : "hover:bg-slate-800"
              }`}
              onClick={() => {
                onSelectPatient(patient);
                onClose();
              }}
              data-testid={`patient-item-${patient.id}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center">
                  <span className="text-sm font-medium text-white">{patient.name?.split(" ").map(n => n[0]).join("")}</span>
                </div>
                <div>
                  <p className="font-medium text-sm text-white">{patient.name}</p>
                  <p className="text-xs text-slate-400">MRN: {patient.mrn || "N/A"}</p>
                </div>
              </div>
            </div>
          ))}
          {filteredPatients.length === 0 && (
            <p className="text-center text-slate-400 py-4">No patients found</p>
          )}
        </div>
      </ScrollArea>
    </div>
  );
}

export default PatientQuickSwitch;
